// // import React, { useState } from 'react';
// // import './Header.css'; 
// // import Logo from "../../assets/logo.png"// Assuming you have a CSS file for styling
// // import Bars  from "../../assets/bars.png"; // Assuming you have a bars icon for mobile menu
// // const Header = () => {
// //   const mobile =window.innerWidth <= 768 ? true : false;
// //   const [menuOpened, setMenuOpened] =useState(false);
// //   return (
// //     <div className="header">
// //       <img src={Logo} alt="" className='logo'/>
// //       {(menuOpened === false && mobile === true)?
// //        ( <div style={{ backgroundColor:"var(--appColor)", padding: '0.5rem', borderRadius: '5px', cursor: 'pointer' }} onClick={() => setMenuOpened(true)}>
// //         <img src={Bars} alt=""  style={{width:'1.5rem',height:'1.5rem'}}/></div>):
// //         <ul className='header-menu'>
// //         <li onclick={()=>setMenuOpened(false)}>Home</li>
// //         <li onclick={()=>setMenuOpened(false)}>Programs</li>
// //         <li onclick={()=>setMenuOpened(false)}>Why Us</li>
// //         <li onclick={()=>setMenuOpened(false)}>Plans</li>
// //         <li onclick={()=>setMenuOpened(false)}>Testimonials</li>
// //       </ul>
// //       }
     

// //     </div>
// //   );
// // }
// // export default Header;
// import React, { useEffect, useState } from 'react';
// import './Header.css';
// import Logo from "../../assets/logo.png";
// import Bars from "../../assets/bars.png";
// import { Link } from 'react-scroll';

// const Header = () => {
//   const [menuOpened, setMenuOpened] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   // Update on resize
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div className="header">
//       <img src={Logo} alt="Logo" className="logo" />

//       {isMobile && !menuOpened ? (
//         <div
//           style={{
//             backgroundColor: "var(--appColor)",
//             padding: "0.5rem",
//             borderRadius: "5px",
//             cursor: "pointer"
//           }}
//           onClick={() => setMenuOpened(true)}
//         >
//           <img src={Bars} alt="Menu" style={{ width: "1.5rem", height: "1.5rem" }} />
//         </div>
//       ) : (
//         <ul className="header-menu">
//           <li>
//             <Link
//              onclick={()=>setMenuOpened(false)}
//               span={true} smooth={true} to="home"
//              >Home</Link>
//           </li>
//         <li>
//             <Link
//              onclick={()=>setMenuOpened(false)}
//               span={true} smooth={true} to="programs"
//              >Programs</Link>
//           </li>
//            <li>
//             <Link
//              onclick={()=>setMenuOpened(false)}
//               span={true} smooth={true} to="reasons"
//              >Why Us</Link>
//           </li>
//            <li>
//             <Link
//              onclick={()=>setMenuOpened(false)}
//               span={true} smooth={true} to="plans"
//              >Plans</Link>
//           </li>
//           <li><Link to ="testimonials" span={true} smooth={true}>Testimonials</Link></li>
//         </ul>
//       )}
//     </div>
//   );
// };

// export default Header;


import React, { useEffect, useState } from 'react';
import './Header.css';
import Logo from "../../assets/logo.png";
import Bars from "../../assets/bars.png";
import { Link } from 'react-scroll';

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="header">
      <img src={Logo} alt="Logo" className="logo" />

      {isMobile && !menuOpened ? (
        <div
          style={{
            backgroundColor: "var(--appColor)",
            padding: "0.5rem",
            borderRadius: "5px",
            cursor: "pointer"
          }}
          onClick={() => setMenuOpened(true)}
        >
          <img src={Bars} alt="Menu" style={{ width: "1.5rem", height: "1.5rem" }} />
        </div>
      ) : (
        <ul className="header-menu">
          <li>
            <Link onClick={() => setMenuOpened(false)} smooth={true} to="home" span={true}>
              Home
            </Link>
          </li>
          <li>
            <Link onClick={() => setMenuOpened(false)} smooth={true} to="programs" span={true}>
              Programs
            </Link>
          </li>
          <li>
            <Link onClick={() => setMenuOpened(false)} smooth={true} to="reasons" span={true}>
              Why Us
            </Link>
          </li>
          <li>
            <Link onClick={() => setMenuOpened(false)} smooth={true} to="plans" span={true}>
              Plans
            </Link>
          </li>
          <li>
            <Link onClick={() => setMenuOpened(false)} smooth={true} to="testimonials" span={true}>
              Testimonials
            </Link>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Header;
